import React from "react";

const InstalliationIcons = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99998 3.49967L6.99998 6.49967M3.99998 3.49967H1.99998L1.33331 1.49967L1.99998 0.833008L3.99998 1.49967V3.49967ZM12.8393 1.32702L11.0876 3.07876C10.8235 3.34277 10.6915 3.47478 10.6421 3.627C10.5986 3.76089 10.5986 3.90512 10.6421 4.03902C10.6915 4.19124 10.8235 4.32324 11.0876 4.58725L11.2457 4.74543C11.5097 5.00944 11.6417 5.14144 11.794 5.1909C11.9279 5.23441 12.0721 5.23441 12.206 5.1909C12.3582 5.14144 12.4902 5.00944 12.7542 4.74543L14.3928 3.10682C14.5693 3.53626 14.6666 4.0066 14.6666 4.49967C14.6666 6.52472 13.025 8.16634 11 8.16634C10.7558 8.16634 10.5173 8.14248 10.2865 8.09696C9.96239 8.03305 9.80034 8.00109 9.7021 8.01088C9.59766 8.02128 9.54619 8.03694 9.45365 8.08646C9.36661 8.13304 9.27929 8.22036 9.10466 8.39499L4.33331 13.1663C3.78103 13.7186 2.8856 13.7186 2.33331 13.1663C1.78103 12.614 1.78103 11.7186 2.33331 11.1663L7.10467 6.39499C7.27929 6.22036 7.36661 6.13304 7.41319 6.046C7.46271 5.95346 7.47837 5.90199 7.48878 5.79755C7.49857 5.69931 7.46661 5.53726 7.40269 5.21317C7.35717 4.98238 7.33331 4.74381 7.33331 4.49967C7.33331 2.47463 8.97494 0.833008 11 0.833008C11.6703 0.833008 12.2986 1.01289 12.8393 1.32702ZM8.00001 9.49964L11.6666 13.1663C12.2189 13.7186 13.1144 13.7186 13.6666 13.1663C14.2189 12.614 14.2189 11.7185 13.6666 11.1663L10.6502 8.14987C10.4367 8.12966 10.2285 8.09114 10.0272 8.0359C9.76779 7.9647 9.48328 8.01638 9.29309 8.20657L8.00001 9.49964Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InstalliationIcons;
